module.exports = __webpack_public_path__ + "static/3dfire-a91b9cb45aa1cecd84438ba8ce86b8fc.svg";